export default {
    frontPageOtherActions: {
        dataTrackId: 'front-page-other-actions',
        dataTrackLinkname: 'forside knapper annet',
    },
    existingCardOptionLinkReplaceExistingCard: {
        dataTrackId: 'existing-card-option-link',
        dataTrackLinkname: 'erstatt eksisterende kort',
    },
    existingCardOptionLinkTerminateCreditCard: {
        dataTrackId: 'existing-card-option-link',
        dataTrackLinkname: 'oppsigelse av kredittkort',
    },
    cardOrderOptionLinkOrderDebitCard: {
        dataTrackId: 'card-order-option-link',
        dataTrackLinkname: 'bestill bankkort',
    },
    cardOrderOptionLinkApplyCreditCard: {
        dataTrackId: 'card-order-option-link',
        dataTrackLinkname: 'sok om kredittkort',
    },
    cardOrderOptionLinkOrderDebitOnSharedAccountCard: {
        dataTrackId: 'card-order-option-link',
        dataTrackLinkname: 'bestill bankkort til felleskonto',
    },
    otherActionContactInfo: {
        dataTrackId: 'card-other-action',
        dataTrackLinkname: 'kontaktinfo',
    },
    otherActionCardDesign: {
        dataTrackId: 'card-other-action',
        dataTrackLinkname: 'kortdesigner',
    },
    otherActionVisaCalculator: {
        dataTrackId: 'card-other-action',
        dataTrackLinkname: 'valutakalkulator',
    },
    cardListMyCards: {
        dataTrackId: 'card-list-my-cards',
        dataTrackLinkname: 'mine kort',
    },
    cardListMyCreditCards: {
        dataTrackId: 'card-list-my-credit-cards',
        dataTrackLinkname: 'mine kredittkort',
    },
    cardListMyDebitCards: {
        dataTrackId: 'card-list-my-debit-cards',
        dataTrackLinkname: 'mine bankkort',
    },
    cardListMyDebitCardsOnSharedAccounts: {
        dataTrackId: 'card-list-my-debit-cards-on-shared-accounts',
        dataTrackLinkname: 'mine bankkort knyttet til felleskontoer',
    },
    cardListOtherCards: {
        dataTrackId: 'card-list-other-cards',
        dataTrackLinkname: 'kort knyttet til felleskontoer',
    },
    cardListPanelItem: {
        dataTrackId: 'card-list-panel-item',
        dataTrackLinkname: 'kort i kortlisten',
    },
};
